
const MyComplaintsOverview = ({ title, cards = [], data = {}, col }) => {
  const displayCards = cards && cards.length > 0 ? cards : Object.keys(CARD_CONFIG);

  const CARD_CONFIG = {
    total: {
      label: 'Total',
      bg: 'bg-light-gray',
    },
    totalActive: {
      label: 'Total Active Complaints',
      bg: 'bg-light-rose',
    },
    escalatedComplaints: {
      label: 'Escalated Complaints',
      bg: 'bg-light-rose',
    },
    pendingResolutions: {
      label: 'Pending Resolutions',
      bg: 'bg-light-yellow',
    },
    inProgress: {
      label: 'In-Progress',
      bg: 'bg-light-pink',
    },
    awaitingReview: {
      label: 'Awaiting Your Review',
      bg: 'bg-light-yellow',
    },
    resolved: {
      label: 'Resolved',
      bg: 'bg-light-green',
    },
    resolvedComplaints: {
      label: 'Resolved Complaints',
      bg: 'bg-light-green',
    },
    reopened: {
      label: 'Reopen',
      bg: 'bg-light-blue',
    },
    closed: {
      label: 'Closed',
      bg: 'bg-light-gray-2',
    },
    closedComplaints: {
      label: 'Closed Complaints',
      bg: 'bg-light-gray-2',
    },
    assigned: {
      label: 'Assigned',
      bg: 'bg-light-blue',
    },
    awaitingConfirmation: {
      label: 'Awaiting Customer Conformation',
      bg: 'bg-light-blue',
    },
  };
  return (
    <div className="card complaints-overview-card h-100 mb-0">
      <div className="card-header border-0 pb-0">
        <h4 className="heading mb-0">{title}</h4>
      </div>
      <div className="card-body">
        <div className="row g-3">
          {displayCards.map((cardKey) => {
            const config = CARD_CONFIG[cardKey] || {
              label: cardKey.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()),
              bg: 'bg-light-gray',
            };
            if(cardKey === "escalatedComplaints") cardKey = "totalActive"
            return (
              <div key={cardKey} className={col || "col-6 col-md-4 col-lg-4"}>
                <div className={`overview-box ${config.bg}`}>
                  <span className="text-muted d-block mb-1">{config.label}</span>
                  <h3 className="mb-0 text-black">{data?.[cardKey] || 0}</h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MyComplaintsOverview;
